import { useSelector } from 'react-redux';
import { RootState } from 'store';

const WelcomeHero: React.FC = () => {
  const isDarkMode = useSelector((state: RootState) => state.theme.isDarkMode);

  return (
    <div className="text-text-primary space-y-5">
      <div className="mb-6">
        <img
          src="/image-to-image.svg"
          alt="Welcome to Image to Image Generator"
          className="max-h-[120px] md:max-h-[146px] h-full"
        />
      </div>
      <h1 className="text-2xl md:text-5xl font-medium text-text-primary lg:leading-[60px] md:max-w-[400px] mb-2">
        Welcome to Image to Image
      </h1>
      <p className="text-sm lg:text-xl font-normal text-text-primary md:w-[400px] mb-6 lg:mb-0">
        Transform your visuals with a free AI image-to-image tool. With Kreaitor, enhance and reimagine your images in seconds!
      </p>
    </div>
  );
};

export default WelcomeHero;
